import type { Logger } from '@devhacker/shared/libs/logger';
import type { IPreviewApi, IPreviewPayload } from '~/types/api/preview';
import { API_URL, API_URL_PREFIX, API_TIMEOUT } from '~/constants/config';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IPreviewApi => {
  const previewFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}${API_URL_PREFIX}`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    headers: {
      cookie: useRequestHeader('cookie') as string,
    },
    ...createLoggerInterceptors($logger, 'preview'),
  });

  return {
    preview(payload: IPreviewPayload) {
      const url = `preview${payload.postId ? `/${payload.postId}` : ''}`;
      const params = { preview_hash: payload.preview_hash };

      if (payload.preview_hash) {
        return previewFetch(`${url}/public`, { params });
      } else {
        return previewFetch(url);
      }
    },
  };
};
